import { internalLinkStyle } from '@bingads-webui-campaign-react/common-styles';

export const getAdTypeItemStyles = (_, { palette = {} }) => ({
  adTypeItem: {
    position: 'relative',
    '&.disabled': {
      opacity: 0.5,
      '& > div': {
        cursor: 'not-allowed',
      },
    },
    '& > div': {
      height: '100%',
      minHeight: 365,
      width: 344,
      cursor: 'pointer',
    },
    '& .title-row': {
      height: 55,
      paddingTop: 18,
      marginLeft: 19,
      marginRight: 19,
      textAlign: 'center',
    },
    '& .img-row': {
      marginLeft: 61,
      marginRight: 61,
      textAlign: 'center',
      marginBottom: 10,
    },
    '& .description-row': {
      minHeight: 128,
      marginLeft: 19,
      marginRight: 19,
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      '& .ad-type-description': {
        ...internalLinkStyle({ palette, isGreyBackground: true }),
      },
    },
  },
  title: {
    color: palette.neutralPrimary,
    lineHeight: '16px',
    fontWeight: 'bold',
  },
  img: {
  },
  description: {
    lineHeight: '16px',
    color: palette.neutralPrimary,
  },
  newFeatureLabel: {
    position: 'absolute',
    marginLeft: '2px',
    marginTop: '2px',
    backgroundColor: '#D83B01',
    color: palette.white,
    borderRadius: 12,
    padding: '0 9px',
    border: `1px solid ${palette.white}`,
    fontSize: 12,
  },
});
